import { StyledTableHead } from "./Table.style";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import PropTypes from "prop-types";
import { MdLibraryAddCheck } from "react-icons/md";
import { IconButton, Tooltip } from "@mui/material";

export default function EnhancedTableHead(props) {
  return (
    <StyledTableHead>
      <TableRow>
        {props.isSelectable && (
          <TableCell padding="checkbox">
            <Tooltip title="انتخاب همه">
              <IconButton onClick={props.onSubmitAll}>
                <MdLibraryAddCheck />
              </IconButton>
            </Tooltip>
          </TableCell>
        )}
        {props.headCells.map((headCell, index) => (
          <TableCell
            key={"headCell" + index}
            padding={headCell.disablePadding ? "none" : "normal"}
            sx={{ color: (theme) => theme.palette.primary.contrastText }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </StyledTableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
};
